module.exports = __webpack_public_path__ + "static/media/gluten.7d0200ec.png";